import { styled } from '@mui/system'

export const IssuesStatsContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 10px;
`
